import {
  getRequiredIndicationDisplay,
  getScaledFont,
  isSupportSpExperimentOn,
} from '@wix/editor-elements-common-utils';
import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import {
  RadioGroupProps as RadioGroupPlatformProps,
  RadioGroupDefinition,
} from '@wix/thunderbolt-components';
import { IRadioGroupStateValues } from '../RadioGroup.types';

export const props = withCompInfo<
  RadioGroupPlatformProps,
  RadioGroupDefinition,
  RadioGroupPlatformProps
>()(
  ['compId', 'language', 'fullNameCompType', 'trackClicksAnalytics'],
  (compProps, carmiData) => {
    return {
      ...carmiData,
      ...compProps,
    };
  },
);

export const css = withCompInfo<any, any>()(
  [
    'compId',
    'compLayout',
    'compProps',
    'styleProperties',
    'isMobileView',
    'hasResponsiveLayout',
    'compData',
    'siteFonts',
    'formatCssValue',
    'experiments',
    'siteFontsSpxResolved',
  ],
  (compInfo, carmiCss) => {
    const { compProps, styleProperties, hasResponsiveLayout, experiments } =
      compInfo;

    const isSupportSpOn = isSupportSpExperimentOn(experiments);

    if (!isSupportSpOn) {
      return carmiCss;
    }

    const {
      alignment,
      buttonsMargin,
      labelMargin,
      buttonSize,
      spacing,
      labelMobileFontSize,
      inputMobileFontSize,
      layout,
    } = compProps;

    const isRightAlignment = alignment === 'right';

    const labelMarginPx = isRightAlignment
      ? `auto ${spacing + 1}px auto auto`
      : `auto auto auto ${spacing + 1}px`;

    const isHorizontalAlignment = layout === 'horizontal';

    const directionProps = isHorizontalAlignment
      ? {
          '--itemsFlexDirection': 'row',
          '--itemsMargin': `0 ${buttonsMargin}px 0 0`,
          '--itemsFlex': '1',
        }
      : {
          '--itemsFlexDirection': 'column',
          '--itemsMargin': `0 0 ${buttonsMargin}px 0`,
          '--itemsWidth': '100%',
        };

    const isResponsive = hasResponsiveLayout;

    const heightProp = isResponsive
      ? {}
      : {
          height: 'auto',
        };

    return {
      '--fnt2': getScaledFont(compInfo, 'fnt2', labelMobileFontSize),
      '--fnt': getScaledFont(compInfo, 'fnt', inputMobileFontSize),
      '--buttonSize': `${buttonSize}px`,
      '--dir': isRightAlignment ? 'rtl' : 'ltr',
      '--flexDirection': isRightAlignment ? 'row-reverse' : 'reverse',
      '--labelMargin': labelMarginPx,
      '--groupLabelMargin': `0 0 ${labelMargin}px 0`,
      '--textAlign': alignment,
      '--requiredIndicationDisplay':
        getRequiredIndicationDisplay(styleProperties),
      ...directionProps,
      ...heightProp,
    };
  },
);

export const stateRefs = withStateRefsValues<keyof IRadioGroupStateValues>([
  'reportBi',
]);

export default createComponentMapperModel({ props, stateRefs, css });
